import { faUpRightFromSquare } from '@fortawesome/pro-regular-svg-icons';
import Button from '@sharedComponents/Button';
import Image from '@sharedComponents/Image';
import Loader from '@sharedComponents/Loader';

import styles from './style.module.css';

export default function LoginHeader({ logo, loading = false, buttonLabel, buttonAction }) {
    return (
        <div className={styles.loginHeader}>
            <div>{loading ? <Loader /> : logo && <Image src={logo} alt="Client Logo" className={styles.logo} />}</div>
            {buttonLabel && <Button label={buttonLabel} action={buttonAction} ghost icon={faUpRightFromSquare} />}
        </div>
    );
}
